import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

export default function imprimirAgenda(imageData, nomePessoa, telefone) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const nomeArquivo = `Agenda_${nomePessoa}.pdf`;

  const docDefinition = {
    info: {
      title: nomeArquivo
    },
    content: [
      {
        text: `Agenda de ${nomePessoa}${telefone}`,
        style: 'header'
      },
      {
        image: imageData,
        width: 500
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'center',
        margin: [0, 0, 0, 20]
      }
    }
  };

  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  return pdfMake.createPdf(docDefinition).open();
}
